export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: (state) => state.all,
    find: (state) =>
      state.all.find((institution) => institution.id == Vue.$route.params.id),
    loading: (state) => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, institutions) {
      state.all = institutions.sort((a, b) => {
        // Alphanumeric sort by Name
        const nameA = a.name.toUpperCase() // ignore upper and lowercase
        const nameB = b.name.toUpperCase() // ignore upper and lowercase

        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      })
      state.loading = false
    },
    set(state, institution) {
      state.all = state.all.filter((o) => o.id != institution.id)
      state.all.push(institution)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('institutions')
        .then(
          (response) => commit('setAll', response.data),
          (response) => commit('stopLoading')
        )
    },
    fetch({ commit }, id) {
      return Vue.$http
        .get(`institutions/${id}`)
        .then((response) => commit('set', response.data))
    }
  }
}
